import { useEffect } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";

/**
 * Backwards-compat for share links from the old (MongoDB) site, which deep-linked
 * by Mongo `_id` via query params instead of path slugs. The migration preserves
 * those ids as the new primary keys, so we just rewrite the URL to the new path
 * form — EntryModal resolves a handle by slug first, then falls back to id.
 *
 *   old: /vault?resource=<id>   ->  new: /vault/<id>
 *   old: /ritual/view?id=<id>   ->  new: /ritual   (rituals unfold inline now)
 */

/** Mounted inside VaultPage: turns `?resource=<id>` into `/vault/<id>`. */
export function useLegacyVaultRedirect() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const resource = params.get("resource");
  useEffect(() => {
    if (resource) navigate(`/vault/${resource}`, { replace: true });
  }, [resource, navigate]);
}

/** Route element for the retired `/ritual/view?id=<id>` page. */
export function LegacyRitualRedirect() {
  return <Navigate to="/ritual" replace />;
}
